import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { useMultiStyleConfig as $, Flex as d, Box as u } from "@chakra-ui/react";
import { useMemo as p } from "react";
import { SelectBase as w } from "../../../forms/Select/SelectBase.mjs";
import { TablePaginationBase as B } from "../../Pagination/TablePaginationBase.mjs";
import { Typography as v } from "../../Typography/Typography.mjs";
const N = ({
  id: m,
  pageSize: r,
  onPageSizeChange: e,
  pageSizeOptions: y = [10, 25, 50, 100],
  totalCount: o,
  currentPage: s,
  isManual: b,
  pageCount: x,
  onPageClick: a
}) => {
  const n = $("Table"), c = p(
    () => b ? Math.ceil(o / r) : x,
    [b, r, o, x]
  ), h = p(
    () => s && r && s * r,
    [s, r]
  ), f = p(
    () => s * r + r,
    [s, r]
  );
  return /* @__PURE__ */ t(d, { sx: n.paginationContainer, children: [
    /* @__PURE__ */ t(d, { sx: n.paginationSize, children: [
      /* @__PURE__ */ i(v, { id: `${m}--pageSize-label`, variant: "bodySmall", children: "Show rows per page:" }),
      /* @__PURE__ */ i(u, { maxW: "100px", children: /* @__PURE__ */ i(
        w,
        {
          size: "sm",
          value: r.toString(),
          onChange: ({ currentTarget: l }) => {
            e == null || e(Number(l.value));
          },
          options: y.map((l) => ({
            label: l.toString(),
            value: l.toString()
          })),
          "aria-labelledby": `${m}--pageSize-label`,
          name: `${m}--pageSize`
        }
      ) })
    ] }),
    /* @__PURE__ */ t(d, { sx: n.paginationButtons, children: [
      /* @__PURE__ */ t(v, { variant: "bodySmall", role: "status", "aria-live": "polite", children: [
        `${h + 1}-${f > o ? o : f}`,
        " ",
        /* @__PURE__ */ t(u, { as: "span", color: "gray.600", children: [
          "of ",
          o
        ] })
      ] }),
      c > 1 && /* @__PURE__ */ i(
        B,
        {
          itemsCount: o,
          itemsPerPage: r,
          pageCount: c,
          onPageClick: ({ selected: l }) => a == null ? void 0 : a(l),
          renderOnZeroPageCount: () => null,
          forcePage: s,
          nextAriaLabel: `Next ${r} rows`,
          previousAriaLabel: `Previous ${r} rows`
        }
      )
    ] })
  ] });
};
export {
  N as TablePagination
};
